import React from "react";
import AppSuspense from "../AppSuspense";
import AppErrorBoundary from "../AppErrorBoundary";
import { StyledMainContentView } from "./index.styled";

type AppContentViewProps = {
  children: React.ReactElement | null;
  minusHeight?: number;
};

const AppContentView: React.FC<AppContentViewProps> = ({
  children,
  minusHeight = 0,
}) => {
  return (
    <StyledMainContentView minusHeight={minusHeight}>
      <AppSuspense>
        <AppErrorBoundary>{children}</AppErrorBoundary>
      </AppSuspense>
    </StyledMainContentView>
  );
};

export default AppContentView;
